import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../../common.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import * as XLSX from 'xlsx';
declare let swal:any;
import { FormBuilder, FormGroup,Validators } from '@angular/forms';
declare var $: any;
@Component({
  selector: 'app-monthly-calculation',
  templateUrl: './monthly-calculation.component.html',
  styleUrls: ['./monthly-calculation.component.css']
})
export class MonthlyCalculationComponent implements OnInit {
  @ViewChild('table') table: ElementRef;
  loginresponse:any;
  userrole:any;
  farm_userrole:any;
  form_id:any;
  getlistApi:any;
  selectallvalue:any;
  getfarmsListData:any;
  loadspeciesValue:any;
  getspeciesvalue:any;
  get_age:any;
  addUrl:any;
  ageUrl :any;
  speciesloaddata:any;
  getData:any=[]; 
  getExportData:any=[]; 
  datatable:boolean=false;
  addtion_total:number=0;
  death_total:number=0;
  deletion_total:number=0;
  closing_total:number=0;
  opening_bal:number=0;
  isLoading:boolean=false;
  closing_balance_end:number=0;
  //closing_tot: number;
  constructor(private router: Router,private commonService: CommonService,private formBuilder: FormBuilder) { }

 async ngOnInit(): Promise<void> {
  this.loginresponse=JSON.parse(sessionStorage.getItem('userrole'));
  this.userrole=this.loginresponse.read_status;
  this.farm_userrole=this.loginresponse.user_farm_id;
  if(this.farm_userrole){
    this.form_id=this.farm_userrole;
  }else{
  this.form_id=null;
  }

  this.isLoading =true;
  var table;
    $('.selectpicker').selectpicker('refresh');
    this.getlistApi=(this.form_id!=null)?'/farms/'+this.form_id:"/farms";
    (await this.commonService.getApi(this.getlistApi)).subscribe(
      async(res) => {
         $(function(){
         table = $("#myTable").DataTable();
         })
         this.getfarmsListData = (this.form_id!=null)?[res.data]:res.data;
         this.getfarmsListData.unshift({tnfr_id:null,tnfr_name:"Select Farm Name"});
  })

  setTimeout(function () {
 //   $('#reportrange_date').daterangepicker('refresh');
    $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
 }, 1500);
 $('#farmname').change(async ()=> {
  $("#speciesid").find('option').remove().end();
  //console.log(  $('#farmname').val())
    this.selectallvalue= $('#farmname').val();
    var farmvalue="";
farmvalue = this.selectallvalue.toString();
this.loadspeciesValue = {
"farms_id":farmvalue
};
//console.log(this.loadspeciesValue.farm_id)
if(farmvalue!="null"){
       //species load in select dropdown based on farm select api call
       this.addUrl = "/species/farms";
       (await this.commonService.postApi(this.addUrl,this.loadspeciesValue)).subscribe(
         res => {
           this.speciesloaddata=res.data;
           this.speciesloaddata.unshift({id:null,name:"Select Species Name"});
           //console.log( this.speciesloaddata)
           
         })
}else{
  $('#Speciesname').val('null');
  this.speciesloaddata=[{id:null,name:"Select Species Name"}];
  $('#BreedName').val('null');
  this.getspeciesvalue=[{id:null,name:"Select Breed Name"}];
 $('#age').val('null');
 this.get_age=[{tnag_id:null,tnag_name:"Select Age",tnag_time_range:'0'}];
}
   


        setTimeout(function () {
          $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
       }, 1500);
  });

  $(document).on('change', '#farmname', function() {
    $('.myFakeClass').dropdown('toggle');
  });
  $(document).on('change', '#Speciesname', function() {
    $('.myFakeClass1').dropdown('toggle');
  });
  $(document).on('change', '#BreedName', function() {
    $('.myFakeClass2').dropdown('toggle');
  });
  $(document).on('change', '#age', function() {
    $('.myFakeClass3').dropdown('toggle');
  });

} 

 

async breedselectbyspecies(event){
  //(event.target.value);
  if(event.target.value!='null'){
  this.addUrl = "/breeds/species/"+event.target.value;
  (await this.commonService.getApi(this.addUrl)).subscribe(
    res => {
         this.getspeciesvalue=res.data;
         this.getspeciesvalue.unshift({id:null,name:"Select Breed Name"});
        //console.log(this.getspeciesvalue);
    }); 
    this.ageUrl="/species/age_group/all_category/?species_id="+event.target.value;
    (await this.commonService.getApi(this.ageUrl)).subscribe(
      res => {
           this.get_age=res.data;
           this.get_age.unshift({tnag_id:null,tnag_name:"Select Age",tnag_time_range:'0'});
         // console.log(this.get_age);
      });


    }else{
      $('#BreedName').val('null');
      this.getspeciesvalue=[{id:null,name:"Select Breed Name"}];
     $('#age').val('null');
     this.get_age=[{tnag_id:null,tnag_name:"Select Age",tnag_time_range:'0'}];
    }
      
    setTimeout(function () {
      $('.selectpicker').selectpicker('refresh');   // refresh the selectpicker with fetched courses
   }, 1000);
}

date_format(dateObject) {
  var d = new Date(dateObject);
  let day = d.getDate();
  var month = d.getMonth() + 1;
  var year = d.getFullYear();
  if (day < 10) {
      var day1 = "0" + day;
  }
  if (month < 10) {
     var month1 = "0" + month;
  }
  var date = year + "-" + month1 + "-" + day1;

  return date;
};

arrayColumn(array, columnName) {
  return array.map(function(value,index) {
      return value[columnName];
  })
}

async get_datas(){

  var getDaysArray = function(start, end) {
    for(var arr=[],dt=new Date(start); dt<=end; dt.setDate(dt.getDate()+1)){
    var date=new Date(dt);
      var d = date.getDate();
		var m = date.getMonth() + 1;
		var y = date.getFullYear();

        arr.push(y+'-' + (m <= 9 ? '0' + m : m)+ '-'+(d <= 9 ? '0' + d : d));
    }
    return arr;
};

//daylist.map((v)=>v.toISOString().slice(0,10)).join("");
//console.log(daylist);

  this.isLoading =true;
  this.datatable=true;
  var table;
  var from_date = $("input[name='daterangepicker_start']" ).val();
  var to_date = $("input[name='daterangepicker_end']" ).val();
//var farm_id=($('#farmname').val()==null)?this.form_id:$('#farmname').val();
var farm_id=(this.form_id!=null)?this.form_id:$('#farmname').val();
var species_id=$('#Speciesname').val();
var breed_id=$('#BreedName').val();
var age=$('#age').val();
var daylist = getDaysArray(new Date(from_date),new Date(to_date));
//console.log(daylist);
//console.log($('div.date_range span').text());
this.getlistApi="/reports/monthly_report/?from_date="+from_date+"&to_date="+to_date+"&farm_id="+farm_id+"&species_id="+species_id+"&breed_id="+breed_id+"&age="+age;
(await this.commonService.getApi(this.getlistApi)).subscribe(
(res) => {         
  setTimeout(() => {
    this.isLoading =false;
    $(function(){
      table = $("#myTable").DataTable();
      })   
        }, 500); 
  //console.log(res.data);

  let dict:any;
  let new_dict = [];
  let anima_days=0;
  let addtion=0;
  let death=0;
  let deletion=0;
  let closing_tot=0;
  this.getData=[];
  this.getExportData=[];
  this.opening_bal=0;
  this.closing_balance_end=0;
  this.addtion_total=0;
  this.death_total=0;
  this.deletion_total=0;
  //this.closing_tot=0;
  this.closing_total=0;
  this.opening_bal= (res.data!=undefined)?res.data[0].opening_count:0;

  this.closing_balance_end=res.data[res.data.length-1].daily_closing_balance;
  for (var i = 0; i < res.data.length; i++) {
   
   // res.data[i]['ad_since']= res.data[i].animal_days+anima_days;
    //dict= res.data[i];
    addtion=res.data[i].additon_count+addtion;
    death=res.data[i].death_count+death;
    deletion=res.data[i].deletion_count+deletion;
   // closing_total=res.data[i].daily_closing_balance+closing_total;
   // new_dict
    
  }
  this.addtion_total=addtion;
  this.death_total=death;
  this.deletion_total=deletion;
  //this.closing_total=closing_total;
  let x=0; 
  let j=0; 
  let y=0;
 
  for(x=0;x<daylist.length;x++){
    for(j=0;j<res.data.length;j++){
      var arr=this.arrayColumn(this.getData, 'date');
      if(arr.includes(daylist[x])==false){
        if(res.data[j].date==daylist[x]){
          
          y=j+1;
          this.getData.push(res.data[j]);
          closing_tot=res.data[j].daily_closing_balance+closing_tot;
          //console.log('true',closing_tot);
        }else{
          var arr1=this.arrayColumn(this.getData, 'date');
         
          if(arr1.includes(res.data[j].date)==false ){
            //console.log("first",y);
            closing_tot=((y==0)?this.opening_bal:res.data[y-1].daily_closing_balance)+closing_tot;
            //console.log('true_else',closing_tot);
            this.getData.push({
              "date": daylist[x],
              "opening_count": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance,
              "additon_count": 0,
              "total_count": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance,
              "death_count": 0,
              "deletion_count": 0,
              "daily_closing_balance": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance
            });
            
          }else{
            if(y==res.data.length){
              closing_tot=(y==0)?this.opening_bal:res.data[y-1].daily_closing_balance+closing_tot;
              //console.log("first2",closing_tot);
              this.getData.push({
                "date": daylist[x],
                "opening_count": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance,
                "additon_count": 0,
                "total_count": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance,
                "death_count": 0,
                "deletion_count": 0,
                "daily_closing_balance": (y==0)?this.opening_bal:res.data[y-1].daily_closing_balance
              });
              
            }
          }

        }
        
      }
     // console.log(closing_tot);
    }
  }
  this.closing_total=closing_tot;
  this.getExportData=this.getData;
  //this.getData =res.data;

   // console.log(this.getData);
  
   }) ;
}

exportdata(){

  const ws: XLSX.WorkSheet=XLSX.utils.table_to_sheet(this.table.nativeElement);
const wb: XLSX.WorkBook = XLSX.utils.book_new();
XLSX.utils.book_append_sheet(wb, ws, 'Monthly_export_' + new Date().getTime() );

/* save to file */
XLSX.writeFile(wb, 'Monthly_export_' + new Date().getTime()+'.xlsx');
  //this.exportAsExcelFile(this.getExportData, 'data');
}

}